
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tenant-price-list",
      function () {
        return require("private-next-pages/tenant-price-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tenant-price-list"])
      });
    }
  